import React from 'react';
import * as app from "../services/AppService"

interface Props { 
    rowClass:string, 
    rowKey:string, 
    colclass:string,  
    colsize:string,
    hide: boolean,
    children?: any,
    style?: object,
    colssize:string
    fixed: boolean,
    alignment: boolean,
    stackOnMd: boolean
}

export default function Row(props: Partial<Props> & { children: any }) {
    if (!document.getElementById("row-stack-style")) {
        const style = document.createElement("style");
        style.id = "row-stack-style";
        style.innerHTML = `
          @media (max-width: 991.98px) {
            .stack-md {}
            .stack-md > [class*="col-"] {
              flex: 0 0 100% !important;
              max-width: 100% !important;
            }
          }`;
        document.head.appendChild(style);
    }
    let Childs = ((Array.isArray(props.children) ? props.children : [props.children]).filter(component => typeof (component) == "object")).filter(c => !app.getBoolean(c.props.hide));  
    return (app.getBoolean(props.hide) ? <></> :
        <div className={`row compact mb-1 ${props.alignment ? "mb-1 align-items-end" : ""} ${props.stackOnMd ? "stack-md" : ""} ${props.rowClass || ''}`} key={props.rowKey} style={props.style}>
            {
                Childs.map((child, index) =>
                    <div key={index}
                        className={props.fixed ? `col${child.props && child.props.colsize ? "-" + child.props.colsize : ""} d-grid  ` :
                            `col-lg${child.props && child.props.colsize ? "-" + child.props.colsize : props.colssize ? "-" + props.colssize : ""}
                        col-md-${Childs.length !== 1 ? "6" : "12"} col-12
                        ${child.props && child.props.colclass ? child.props.colclass : props.colclass ? props.colclass : ''}`}>
                        {child}
                    </div>)
            }
        </div>
    );
}